/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SystemControllerDtoSysMaintenanceListRequest model module.
 * @module model/SystemControllerDtoSysMaintenanceListRequest
 * @version 1.0
 */
class SystemControllerDtoSysMaintenanceListRequest {
    /**
     * Constructs a new <code>SystemControllerDtoSysMaintenanceListRequest</code>.
     * @alias module:model/SystemControllerDtoSysMaintenanceListRequest
     * @param page {Number} 
     * @param pageLength {Number} 
     */
    constructor(page, pageLength) { 
        
        SystemControllerDtoSysMaintenanceListRequest.initialize(this, page, pageLength);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, page, pageLength) { 
        obj['page'] = page;
        obj['pageLength'] = pageLength;
    }

    /**
     * Constructs a <code>SystemControllerDtoSysMaintenanceListRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SystemControllerDtoSysMaintenanceListRequest} obj Optional instance to populate.
     * @return {module:model/SystemControllerDtoSysMaintenanceListRequest} The populated <code>SystemControllerDtoSysMaintenanceListRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SystemControllerDtoSysMaintenanceListRequest();

            if (data.hasOwnProperty('page')) {
                obj['page'] = ApiClient.convertToType(data['page'], 'Number');
            }
            if (data.hasOwnProperty('pageLength')) {
                obj['pageLength'] = ApiClient.convertToType(data['pageLength'], 'Number');
            }
            if (data.hasOwnProperty('skip')) {
                obj['skip'] = ApiClient.convertToType(data['skip'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SystemControllerDtoSysMaintenanceListRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SystemControllerDtoSysMaintenanceListRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of SystemControllerDtoSysMaintenanceListRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }

        return true;
    }


}

SystemControllerDtoSysMaintenanceListRequest.RequiredProperties = ["page", "pageLength"];

/**
 * @member {Number} page
 */
SystemControllerDtoSysMaintenanceListRequest.prototype['page'] = undefined;

/**
 * @member {Number} pageLength
 */
SystemControllerDtoSysMaintenanceListRequest.prototype['pageLength'] = undefined;

/**
 * @member {Number} skip
 */
SystemControllerDtoSysMaintenanceListRequest.prototype['skip'] = undefined;






export default SystemControllerDtoSysMaintenanceListRequest;

